import React, { useState } from "react";
import Navbar from "../component/Navbar";
import { Link } from "react-router-dom";
import Webimagefooter from "../component/Signup/Webimagefooter";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { url } from "../api/api";
import Activityindicator from "../Activityindicator";

const Signup = () => {
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    password: "",
  });

  const [isLoading, setisLoading] = useState(false);

  const [error, seterrorStatus] = useState("");
  const navigate = useNavigate();

  console.log(error);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setisLoading(true);
    const newData = {
      fullname: formData.fullname,
      email: formData.email,
      password: formData.password,
      isAdmin: false,
    };
    await axios
      .post(`${url}/users/register`, newData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // Process the successful response here
        setisLoading(false);
        localStorage.setItem("useridkey", response.data.userid);

        navigate("/verifyemail");
      })
      .catch((error) => {
        // Handle error responses here
        if (error.response) {
          if (error.response.status === 422) {
            seterrorStatus("User email already exist");
            setisLoading(false);
          } else {
            seterrorStatus("Unknown error exist while submiting form");
            setisLoading(false);
          }
        } else {
          console.error("Error:", error.message);
          setisLoading(false);
        }
      });
  };

  return (
    <div className="w-full bg-[radial-gradient(89.62%_213.03%_at_38.75%_80.3%,_#07031C_0%,_#241D4A_30.52%,_#07031C_64.32%)]">
      <Navbar />

      <div className=" w-full h-[800px]  md:h-[750px] grid place-items-center z-50">
        <div className="  bg-transparent md:border-[1px] border-[#D4F5F9] border-opacity-30 text-white rounded-lg shadow-lg p-8 max-w-sm w-full">
          <div className="px-4 py-4">
            <h2 className="text-[20px] font-bold  font-istok mb-6 text-center text-[#F2C493]">
              Create A Personal Account
            </h2>
            <p className=" text-[14px]  text-blue-200  font-lato mt-[-25px] text-center">
              welcome to the future of secure crypto investment{" "}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4 mt-[30px]">
            {error && <h2 className="text-red-500"> {error}</h2>}
            <div>
              <label
                htmlFor="fullname"
                className="block text-[12px] font-medium mb-1 text-[#FFFFFF] font-lato"
              >
                Fullname
              </label>
              <input
                type="fullname"
                id="fullname"
                className="focus:bg-transparent focus:outline-none w-full px-3 py-2 border border-[#D4F5F94D] bg-transparent rounded-[10px] "
                name="fullname"
                value={formData.fullname}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-[12px] font-medium mb-1 text-[#FFFFFF] font-lato"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                className="focus:bg-transparent focus:outline-none w-full px-3 py-2 border border-[#D4F5F94D]  bg-transparent rounded-[15px] "
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label
                htmlFor="password"
                className="focus:bg-transparent focus:outline-none block text-[12px] font-medium mb-1 text-[#FFFFFF] font-lato"
              >
                Password
              </label>
              <input
                type="password"
                id="password"
                className="w-full px-3 py-2 bg-transparent  border border-[#D4F5F94D] rounded-[10px]"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            <p className=" text-[#D4F5F9] text-[16px] font-istok">
              By Creating an account, I agree to  Capital Nest’s terms and
              condition
            </p>

            <br />

            <div className=" mt-[146px]">
              {isLoading ? (
                <Activityindicator />
              ) : (
                <button
                  type="submit"
                  className=" text-[16px]  text-[#00001A] font-istok w-full py-4 px-4 bg-[#D4F5F9] rounded-md  focus:outline-none focus:ring-2 focus:ring-black "
                >
                  Get Started
                </button>
              )}
            </div>

            <p className=" text-[#FFFFFF] font-istok mt-[20px] ">
              Already have an account?{" "}
              <Link to="/login" className="text-[#F2C493] font-istok cursor-pointer">
              Sign in
              </Link>
              {" "}
               Instead
            </p>
           
          </form>
        </div>
      </div>

      <Webimagefooter />
    </div>
  );
};

export default Signup;
